<template>
    <article class="product-miniature js-product-miniature">
        <div class="thumbnail-container">
            <a :href="getUrl()" class="thumbnail product-thumbnail">
                <img :src="bestseller.imageDefault" class="img-product" :alt="bestseller.name"/>
                <div class="product-stocked" v-if="bestseller.available_for_order == 1">
                    <span>En stock</span>
                </div>
                <div class="product-sur-mesure" v-else>
                    <span>Sur-mesure</span>
                </div>
            </a>
            <div class="product-description">
                <h3 class="product-title" itemprop="name">
                    <a :href="getUrl()">{{ bestseller.name }}</a>
                </h3>
                <div class="h3 product-price-and-shipping" v-if="bestseller.show_price == 1">
                    <span class="sr-only">Prix</span>
                    <p class="price-accroche">À partir de </p>
                    <p itemprop="price" class="price">{{bestseller.lowest_price|formatPrice}} <span class="package">/ {{lot}}</span></p>
                </div>

                <div class="h3 product-price-and-shipping" v-else>
                    <span class="sr-only">Prix</span>
                    <p class="price-accroche">Sur devis </p>
                    <p itemprop="price" class="price">Devis gratuit 24H</p>
                </div>
            </div>

            <span class="product-of-category" v-if="caract" :style="tabColor">
                {{caract}}
            </span>
        </div>
    </article>
</template>

<script>
    import {mapGetters} from 'vuex'
    import * as types from '../store/types';
    import {_PRODUCT_FEATURE_NAME, _PRODUCT_FEATURE_VALUE, _CATEGORIES} from '../api'
    import {_NAME_FEATURE_CARACT, _NAME_NUMBER_PIECES} from '../api/type'
    import '../style/Product.scss';

    export default {
        name: 'Bestseller',
        props: {
            bestseller: Object
        },
        computed: {
            ...mapGetters({
                getHostname: types.GET_HOSTNAME,
            }),
            caract() {
                if (!this.features.length) return;
                const caract = this.features.find(feature => {
                    return feature.name === _NAME_FEATURE_CARACT;
                });
                return caract ? caract.value : '';
            },
            lot() {
                if (!this.features.length) return;
                const numbPiece = this.features.find(feature => {
                    return feature.name === _NAME_NUMBER_PIECES;
                });
                return numbPiece ? numbPiece.value : '';
            },
            tabColor() {
                return {
                    backgroundColor: this.color
                };
            }
        },
        data() {
            return {
                features: [],
                color: ''
            }
        },
        mounted() {
            this.getProductFeatures();
            this.getColor()
        },
        methods: {
            ...mapGetters({
                getUrlProduct: types.GET_URL_PRODUCT,
            }),
            getUrl() {
                return this.getUrlProduct()(this.bestseller.id, this.getHostname);
            },
            getProductFeatures() {
                const {
                    associations : {product_features}
                } = this.bestseller;

                if (!Array.isArray(product_features) || !product_features.length) {
                    return ""
                }

                product_features
                    .filter(ele => ["1","2"].includes(ele.id))
                    .forEach(({id, id_feature_value}) => {
                        this.$http.get(
                            [_PRODUCT_FEATURE_NAME, id].join('/'), {
                                params: {
                                    output_format: 'JSON'
                                }
                            })
                            .then(response => {
                                return response.json();
                            })
                            .then(({product_feature: {name}}) => {
                                this.$http.get(
                                    [_PRODUCT_FEATURE_VALUE, id_feature_value].join('/'), {
                                        params: {
                                            output_format: 'JSON'
                                        }
                                    })
                                    .then(response => {
                                        return response.json();
                                    })
                                    .then(({product_feature_value: {value}}) => {
                                        this.features.push({
                                            name,
                                            value
                                        })
                                    });
                            });
                });

            },
            getColor() {
                const {id_category_default} = this.bestseller;
                if (!id_category_default) {
                    return;
                }

                this.$http.get(
                    [_CATEGORIES, id_category_default].join('/'), {
                        params: {
                            output_format: 'JSON'
                        }
                    })
                    .then(response => {
                        return response.json();
                    })
                    .then(({category: {category_color}}) => {
                        this.color = category_color;
                    });
            }
        },
        filters: {
            formatPrice(value) {
                return ((Math.round(value * 100) / 100).toFixed(2) + ' €').replace('.', ',');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Bestseller.vue